import CryptoJS from 'crypto-js';
const KEY = '4f3c2e1d5b6a7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2c';

export const secureStorage = {
  getItem: (name) => {
    const data = sessionStorage.getItem(name);
    if (!data) return null;
    try {
      const decrypted = CryptoJS.AES.decrypt(data, KEY).toString(
        CryptoJS.enc.Utf8
      );
      return decrypted || null;
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    const encrypted = CryptoJS.AES.encrypt(value, KEY).toString();
    sessionStorage.setItem(name, encrypted);
  },
  removeItem: (name) => {
    sessionStorage.removeItem(name);
  }
};
